const isDevServer = typeof window !== "undefined" && window.location.port === "3000";
export const serverDomain = isDevServer 
  ? "http://localhost:8443" 
  : (typeof window !== "undefined" ? `${window.location.origin}/api` : "/api");